import { FC, memo } from 'react';
import { Stack, Text } from '@chakra-ui/react';

import {
  AnyDocument,
  DataSectionDataItem,
  WorkflowDataResolverDependencies,
} from '../../../shared/types';
import { useEvaluatedValue } from '../../hooks/useEvaluatedValue';
import { OptionallyDisplayWhen } from '../OptionallyDisplayWhen';

type DataSectionPresenterItemProps = {
  label: DataSectionDataItem['label'];
  value: DataSectionDataItem['value'];
  displayWhen?: DataSectionDataItem['displayWhen'];
  workflowDataResolverDependencies?: Partial<WorkflowDataResolverDependencies>;
  parentContext?: AnyDocument;
};

const DataSectionPresenterItemComponent: FC<DataSectionPresenterItemProps> = ({
  label,
  value,
  displayWhen,
  parentContext,
  workflowDataResolverDependencies,
}) => {
  const evaluatedValue = useEvaluatedValue(
    value,
    workflowDataResolverDependencies,
    parentContext,
  );

  return (
    <OptionallyDisplayWhen
      evaluatable={displayWhen}
      workflowDataResolverDependencies={workflowDataResolverDependencies}
    >
      <Stack gap={2}>
        <Text fontWeight="medium">{label}</Text>

        <Text>{evaluatedValue || '-'}</Text>
      </Stack>
    </OptionallyDisplayWhen>
  );
};

export const DataSectionPresenterItem = memo(DataSectionPresenterItemComponent);
